const webProtocols = new Set(['http:', 'https:']);

export const navigateExternal = (url: string): void => {
  const { protocol } = new URL(url, window.location.href);

  if (!webProtocols.has(protocol)) {
    return;
  }

  window.location.assign(url);
};
